import { render, staticRenderFns } from "./PropostaInfoColumn.vue?vue&type=template&id=42fd7418&scoped=true&"
import script from "./PropostaInfoColumn.vue?vue&type=script&lang=js&"
export * from "./PropostaInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./PropostaInfoColumn.vue?vue&type=style&index=0&id=42fd7418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd7418",
  null
  
)

export default component.exports